<template>
    <div v-if="show" class="event_popup_view flex_center">
      <div class="event_popup">
        <div @click="eventClick" class="event_popup_img">
          <template v-if="imgURL.trim().length > 0 ">
            <img :src="imgURL" />
          </template>
        </div>
        <div class="event_popup_close flex_between">
          <div @click="todayCloseCheck()" :class="today_close_check ? 'today_close_check' :'' " class="flex_center">
            오늘 그만 보기
          </div>
          <div @click="close">
            닫기
          </div>
        </div>
      </div>
    </div>
</template>

<script>
	export default {
		name: "eventPopup"
    ,data(){
		  return {
        show:false
        ,imgURL : ''
        ,linkURL : ''
        ,today_close_check:false
        ,success:null
      }
    }
    ,methods:{
      todayCloseCheck(){
        this.today_close_check = !this.today_close_check;
      }
      ,close(){
        this.success(this.today_close_check);
      }
      ,eventClick(){
        if(this.linkURL !== '' ){
          location.href = this.linkURL;
        }
      }
    }
	}
</script>

<style scoped>
  .event_popup_view {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.3);
    z-index: 10000;
  }

  .event_popup {

    width: 8.611rem;
    height: 11.389rem;
    background-color: #fff;
    border: 1px solid #C8C8C8;
  }

  .event_popup_img {
    height: 9.889rem;
    width: 100%;
  }
  .event_popup_img img {
    height: 100%;
    width: 100%;
  }

  .event_popup_close {
    height: 1.5rem;
  }

  .event_popup_close > div:nth-child(1) {
    padding: 0 0 0 1.056rem;
    margin:  0 0 0 0.556rem;
    height: 0.778rem;
    position: relative;

  }

  .event_popup_close > .today_close_check:nth-child(1):before {
    background-image: url("../assets/icon/icon_check_on.png")!important;
  }

  .event_popup_close > div:nth-child(1):before{
    content: '';
    background-image: url("../assets/icon/icon_check_off.png");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
    position: absolute;

    left: 0;
    width: 0.778rem;
    height: 0.778rem;
    -webkit-border-radius: 0.139rem;
    -moz-border-radius: 0.139rem;
    border-radius: 0.139rem;
    border: 1px solid #C8C8C8;
  }

  .event_popup_close div:nth-child(2) {
    padding: 0 0.556rem 0 0;
    color: #F15929;
  }
</style>



// WEBPACK FOOTER //
// src/components/eventPopup.vue